import { render } from "./IncomingProperties.vue?vue&type=template&id=64dac6c7&scoped=true"
import script from "./IncomingProperties.vue?vue&type=script&lang=js"
export * from "./IncomingProperties.vue?vue&type=script&lang=js"

import "./IncomingProperties.vue?vue&type=style&index=0&id=64dac6c7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dac6c7"]])

export default __exports__